import styled from 'styled-components'

const DividingLineCont = styled.div`
  background: rgba(67, 75, 87, 0.31);
  height: 1px;
  margin-top: 1rem;
`

const DividingLine = () => {
  return <DividingLineCont />
}

export default DividingLine
